import axios from 'axios';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash, FaUser, FaLock, FaPhone, FaSignInAlt, FaEnvelope, FaChevronDown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { BASE_API_URL } from '../helpers/Config';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const LoginScreen = ({ theme = 'dark' }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    const [loginType, setLoginType] = useState('mobile'); // 'mobile' or 'email'
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const isDarkMode = theme === 'dark';

    // Country codes (same as before)
    const countryCodes = [
        { code: '1', country: 'United States' },
        { code: '7', country: 'Russia' },
        { code: '20', country: 'Egypt' },
        { code: '27', country: 'South Africa' },
        { code: '30', country: 'Greece' },
        { code: '31', country: 'Netherlands' },
        { code: '32', country: 'Belgium' },
        { code: '33', country: 'France' },
        { code: '34', country: 'Spain' },
        { code: '36', country: 'Hungary' },
        { code: '39', country: 'Italy' },
        { code: '40', country: 'Romania' },
        { code: '41', country: 'Switzerland' },
        { code: '43', country: 'Austria' },
        { code: '44', country: 'United Kingdom' },
        { code: '45', country: 'Denmark' },
        { code: '46', country: 'Sweden' },
        { code: '47', country: 'Norway' },
        { code: '48', country: 'Poland' },
        { code: '49', country: 'Germany' },
        { code: '51', country: 'Peru' },
        { code: '52', country: 'Mexico' },
        { code: '53', country: 'Cuba' },
        { code: '54', country: 'Argentina' },
        { code: '55', country: 'Brazil' },
        { code: '56', country: 'Chile' },
        { code: '57', country: 'Colombia' },
        { code: '58', country: 'Venezuela' },
        { code: '60', country: 'Malaysia' },
        { code: '61', country: 'Australia' },
        { code: '62', country: 'Indonesia' },
        { code: '63', country: 'Philippines' },
        { code: '64', country: 'New Zealand' },
        { code: '65', country: 'Singapore' },
        { code: '66', country: 'Thailand' },
        { code: '81', country: 'Japan' },
        { code: '82', country: 'South Korea' },
        { code: '84', country: 'Vietnam' },
        { code: '86', country: 'China' },
        { code: '90', country: 'Turkey' },
        { code: '91', country: 'India' },
        { code: '92', country: 'Pakistan' },
        { code: '93', country: 'Afghanistan' },
        { code: '94', country: 'Sri Lanka' },
        { code: '95', country: 'Myanmar' },
        { code: '98', country: 'Iran' },
        { code: '212', country: 'Morocco' },
        { code: '213', country: 'Algeria' },
        { code: '216', country: 'Tunisia' },
        { code: '218', country: 'Libya' },
        { code: '220', country: 'Gambia' },
        { code: '221', country: 'Senegal' },
        { code: '222', country: 'Mauritania' },
        { code: '223', country: 'Mali' },
        { code: '224', country: 'Guinea' },
        { code: '225', country: 'Ivory Coast' },
        { code: '226', country: 'Burkina Faso' },
        { code: '227', country: 'Niger' },
        { code: '228', country: 'Togo' },
        { code: '229', country: 'Benin' },
        { code: '230', country: 'Mauritius' },
        { code: '231', country: 'Liberia' },
        { code: '232', country: 'Sierra Leone' },
        { code: '233', country: 'Ghana' },
        { code: '234', country: 'Nigeria' },
        { code: '235', country: 'Chad' },
        { code: '236', country: 'Central African Republic' },
        { code: '237', country: 'Cameroon' },
        { code: '238', country: 'Cape Verde' },
        { code: '239', country: 'Sao Tome and Principe' },
        { code: '240', country: 'Equatorial Guinea' },
        { code: '241', country: 'Gabon' },
        { code: '242', country: 'Republic of the Congo' },
        { code: '243', country: 'Democratic Republic of the Congo' },
        { code: '244', country: 'Angola' },
        { code: '245', country: 'Guinea-Bissau' },
        { code: '246', country: 'British Indian Ocean Territory' },
        { code: '248', country: 'Seychelles' },
        { code: '249', country: 'Sudan' },
        { code: '250', country: 'Rwanda' },
        { code: '251', country: 'Ethiopia' },
        { code: '252', country: 'Somalia' },
        { code: '253', country: 'Djibouti' },
        { code: '254', country: 'Kenya' },
        { code: '255', country: 'Tanzania' },
        { code: '256', country: 'Uganda' },
        { code: '257', country: 'Burundi' },
        { code: '258', country: 'Mozambique' },
        { code: '260', country: 'Zambia' },
        { code: '261', country: 'Madagascar' },
        { code: '262', country: 'Reunion' },
        { code: '263', country: 'Zimbabwe' },
        { code: '264', country: 'Namibia' },
        { code: '265', country: 'Malawi' },
        { code: '266', country: 'Lesotho' },
        { code: '267', country: 'Botswana' },
        { code: '268', country: 'Swaziland' },
        { code: '269', country: 'Comoros' },
        { code: '290', country: 'Saint Helena' },
        { code: '291', country: 'Eritrea' },
        { code: '297', country: 'Aruba' },
        { code: '298', country: 'Faroe Islands' },
        { code: '299', country: 'Greenland' },
        { code: '350', country: 'Gibraltar' },
        { code: '351', country: 'Portugal' },
        { code: '352', country: 'Luxembourg' },
        { code: '353', country: 'Ireland' },
        { code: '354', country: 'Iceland' },
        { code: '355', country: 'Albania' },
        { code: '356', country: 'Malta' },
        { code: '357', country: 'Cyprus' },
        { code: '358', country: 'Finland' },
        { code: '359', country: 'Bulgaria' },
        { code: '370', country: 'Lithuania' },
        { code: '371', country: 'Latvia' },
        { code: '372', country: 'Estonia' },
        { code: '373', country: 'Moldova' },
        { code: '374', country: 'Armenia' },
        { code: '375', country: 'Belarus' },
        { code: '376', country: 'Andorra' },
        { code: '377', country: 'Monaco' },
        { code: '378', country: 'San Marino' },
        { code: '379', country: 'Vatican City' },
        { code: '380', country: 'Ukraine' },
        { code: '381', country: 'Serbia' },
        { code: '382', country: 'Montenegro' },
        { code: '383', country: 'Kosovo' },
        { code: '385', country: 'Croatia' },
        { code: '386', country: 'Slovenia' },
        { code: '387', country: 'Bosnia and Herzegovina' },
        { code: '389', country: 'North Macedonia' },
        { code: '420', country: 'Czech Republic' },
        { code: '421', country: 'Slovakia' },
        { code: '423', country: 'Liechtenstein' },
        { code: '500', country: 'Falkland Islands' },
        { code: '501', country: 'Belize' },
        { code: '502', country: 'Guatemala' },
        { code: '503', country: 'El Salvador' },
        { code: '504', country: 'Honduras' },
        { code: '505', country: 'Nicaragua' },
        { code: '506', country: 'Costa Rica' },
        { code: '507', country: 'Panama' },
        { code: '508', country: 'Saint Pierre and Miquelon' },
        { code: '509', country: 'Haiti' },
        { code: '590', country: 'Guadeloupe' },
        { code: '591', country: 'Bolivia' },
        { code: '592', country: 'Guyana' },
        { code: '593', country: 'Ecuador' },
        { code: '594', country: 'French Guiana' },
        { code: '595', country: 'Paraguay' },
        { code: '596', country: 'Martinique' },
        { code: '597', country: 'Suriname' },
        { code: '598', country: 'Uruguay' },
        { code: '599', country: 'Netherlands Antilles' },
        { code: '670', country: 'East Timor' },
        { code: '672', country: 'Norfolk Island' },
        { code: '673', country: 'Brunei' },
        { code: '674', country: 'Nauru' },
        { code: '675', country: 'Papua New Guinea' },
        { code: '676', country: 'Tonga' },
        { code: '677', country: 'Solomon Islands' },
        { code: '678', country: 'Vanuatu' },
        { code: '679', country: 'Fiji' },
        { code: '680', country: 'Palau' },
        { code: '681', country: 'Wallis and Futuna' },
        { code: '682', country: 'Cook Islands' },
        { code: '683', country: 'Niue' },
        { code: '685', country: 'Samoa' },
        { code: '686', country: 'Kiribati' },
        { code: '687', country: 'New Caledonia' },
        { code: '688', country: 'Tuvalu' },
        { code: '689', country: 'French Polynesia' },
        { code: '690', country: 'Tokelau' },
        { code: '691', country: 'Micronesia' },
        { code: '692', country: 'Marshall Islands' },
        { code: '850', country: 'North Korea' },
        { code: '852', country: 'Hong Kong' },
        { code: '853', country: 'Macau' },
        { code: '855', country: 'Cambodia' },
        { code: '856', country: 'Laos' },
        { code: '872', country: 'International' },
        { code: '880', country: 'Bangladesh' },
        { code: '886', country: 'Taiwan' },
        { code: '960', country: 'Maldives' },
        { code: '961', country: 'Lebanon' },
        { code: '962', country: 'Jordan' },
        { code: '963', country: 'Syria' },
        { code: '964', country: 'Iraq' },
        { code: '965', country: 'Kuwait' },
        { code: '966', country: 'Saudi Arabia' },
        { code: '967', country: 'Yemen' },
        { code: '968', country: 'Oman' },
        { code: '970', country: 'Palestine' },
        { code: '971', country: 'United Arab Emirates' },
        { code: '972', country: 'Israel' },
        { code: '973', country: 'Bahrain' },
        { code: '974', country: 'Qatar' },
        { code: '975', country: 'Bhutan' },
        { code: '976', country: 'Mongolia' },
        { code: '977', country: 'Nepal' },
        { code: '992', country: 'Tajikistan' },
        { code: '993', country: 'Turkmenistan' },
        { code: '994', country: 'Azerbaijan' },
        { code: '995', country: 'Georgia' },
        { code: '996', country: 'Kyrgyzstan' },
        { code: '998', country: 'Uzbekistan' }
    ].sort((a, b) => a.country.localeCompare(b.country));

    // Create separate validation functions instead of using Yup's when()
    const validateForm = (values) => {
        const errors = {};

        // Validate loginValue based on loginType
        if (!values.loginValue) {
            errors.loginValue = loginType === 'mobile'
                ? 'Mobile number is required'
                : 'Email address is required';
        } else if (loginType === 'mobile') {
            if (!/^\d+$/.test(values.loginValue)) {
                errors.loginValue = 'Mobile number must contain only digits';
            }
        } else if (loginType === 'email') {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.loginValue)) {
                errors.loginValue = 'Please enter a valid email address';
            }
        }

        // Validate password
        if (!values.password) {
            errors.password = 'Password is required';
        }

        // Validate countryCode for mobile login
        if (loginType === 'mobile' && !values.countryCode) {
            errors.countryCode = 'Country code is required';
        }

        return errors;
    };

    const formik = useFormik({
        initialValues: {
            loginValue: '',
            password: '',
            countryCode: '91' // Default to India
        },
        validate: validateForm,
        onSubmit: async (values) => {
            setIsLoading(true);
            try {
                const payload = {
                    password: values.password
                };

                if (loginType === 'mobile') {
                    // For mobile login: send mobile with country_code
                    payload.type = 'mobile';
                    payload.mobile = values.loginValue;
                    payload.country_code = values.countryCode;
                } else {
                    payload.type = 'email';
                    // For email login: send email
                    payload.email = values.loginValue;
                }

                const res = await axios.post(`${BASE_API_URL}/auth/login`, payload);
                const data = res?.data;

                if (data?.error) {
                    toast.error(data?.error);
                    return;
                }

                if (data?.msg) {
                    toast.success(data?.msg);
                    const token = data?.token;
                    const balance = data?.balance;
                    const usdt = data?.usdt;
                    localStorage.setItem("a5srf4wer7w1cd", token);
                    localStorage.setItem("balance", balance);
                    localStorage.setItem("usdt_balance", usdt);
                    setTimeout(() => {
                        navigate('/', { replace: true });
                    }, 1000);
                }

            } catch (error) {
                console.error('Login error:', error);
                if (error.response?.data?.error) {
                    toast.error(error.response.data.error);
                } else {
                    toast.error('Login failed. Please try again.');
                }
            } finally {
                setIsLoading(false);
            }
        }
    });

    // Get selected country
    const selectedCountry = countryCodes.find(country => country.code === formik.values.countryCode);

    const handleCountrySelect = (countryCode) => {
        formik.setFieldValue('countryCode', countryCode);
        setShowCountryDropdown(false);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleLoginTypeChange = (type) => {
        setLoginType(type);
        // Clear validation errors when switching types
        formik.setFieldTouched('loginValue', false);
        formik.setFieldError('loginValue', null);
        formik.setFieldValue('loginValue', '');
    };

    // Reset validation when login type changes
    useEffect(() => {
        // Trigger validation on login type change
        if (formik.touched.loginValue || formik.touched.password) {
            formik.validateForm();
        }
    }, [loginType]);

    // Theme-aware styles
    const styles = {
        container: {
            width: '100%',
            maxWidth: '100%',
            background: 'transparent',
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            padding: '10px'
        },
        formContainer: {
            background: isDarkMode ? '#2d3748' : '#ffffff',
            borderRadius: '12px',
            padding: '24px',
            boxShadow: isDarkMode
                ? '0 4px 12px rgba(0, 0, 0, 0.3)'
                : '0 2px 8px rgba(0, 0, 0, 0.1)',
            border: isDarkMode ? '1px solid #4a5568' : '1px solid #e2e8f0',
            maxWidth: '420px',
            margin: '0 auto'
        },
        header: {
            textAlign: 'center',
            marginBottom: '20px'
        },
        logoContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '16px'
        },
        logoImage: {
            width: '80px',
            height: 'auto',
            marginBottom: '12px',
            borderRadius: '8px',
            objectFit: 'contain'
        },
        title: {
            fontSize: '20px',
            fontWeight: '700',
            color: isDarkMode ? '#e2e8f0' : '#2d3748',
            margin: '0 0 6px 0'
        },
        subtitle: {
            fontSize: '12px',
            color: isDarkMode ? '#a0aec0' : '#718096',
            margin: 0,
            fontWeight: '400'
        },
        form: {
            width: '100%'
        },
        // Login Type Selector
        typeSelector: {
            display: 'flex',
            marginBottom: '20px',
            borderRadius: '8px',
            overflow: 'hidden',
            border: isDarkMode ? '1px solid #4a5568' : '1px solid #e2e8f0',
            backgroundColor: isDarkMode ? '#4a5568' : '#f8f9fa'
        },
        typeButton: {
            flex: 1,
            padding: '10px',
            fontSize: '12px',
            fontWeight: '600',
            border: 'none',
            backgroundColor: 'transparent',
            color: isDarkMode ? '#a0aec0' : '#718096',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px'
        },
        typeButtonActive: {
            backgroundColor: isDarkMode ? '#68d391' : '#38a169',
            color: '#ffffff'
        },
        formGroup: {
            marginBottom: '16px'
        },
        labelContainer: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '6px'
        },
        labelIcon: {
            color: isDarkMode ? '#68d391' : '#38a169',
            fontSize: '12px',
            marginRight: '6px'
        },
        label: {
            fontSize: '12px',
            fontWeight: '600',
            color: isDarkMode ? '#e2e8f0' : '#2d3748'
        },
        inputContainer: {
            position: 'relative',
            width: '100%'
        },
        input: {
            width: '100%',
            padding: '10px 12px',
            fontSize: '14px',
            border: `1px solid ${isDarkMode ? '#4a5568' : '#e2e8f0'}`,
            borderRadius: '6px',
            backgroundColor: isDarkMode ? '#4a5568' : '#ffffff',
            color: isDarkMode ? '#e2e8f0' : '#2d3748',
            transition: 'all 0.2s ease',
            outline: 'none',
            boxSizing: 'border-box',
            fontWeight: '400'
        },
        inputError: {
            borderColor: '#fc8181',
            backgroundColor: isDarkMode ? '#742a2a' : '#fff5f5'
        },
        inputSuccess: {
            borderColor: '#68d391'
        },
        successIcon: {
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#68d391',
            fontSize: '14px'
        },
        errorText: {
            color: '#fc8181',
            fontSize: '11px',
            marginTop: '4px',
            display: 'block',
            fontWeight: '500'
        },
        passwordToggle: {
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: isDarkMode ? '#a0aec0' : '#718096',
            fontSize: '14px',
            zIndex: 2,
            transition: 'color 0.2s ease'
        },
        toggleIcon: {
            fontSize: '14px'
        },
        mobileInputContainer: {
            display: 'flex',
            gap: '8px',
            alignItems: 'center'
        },
        countrySelector: {
            position: 'relative',
            minWidth: '120px'
        },
        countryButton: {
            padding: '10px 8px',
            fontSize: '14px',
            border: `1px solid ${isDarkMode ? '#4a5568' : '#e2e8f0'}`,
            borderRadius: '6px',
            backgroundColor: isDarkMode ? '#4a5568' : '#ffffff',
            color: isDarkMode ? '#e2e8f0' : '#2d3748',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '4px',
            minWidth: '120px',
            height: '40px'
        },
        countryDropdown: {
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: isDarkMode ? '#4a5568' : '#ffffff',
            border: `1px solid ${isDarkMode ? '#718096' : '#e2e8f0'}`,
            borderRadius: '6px',
            boxShadow: isDarkMode
                ? '0 4px 12px rgba(0, 0, 0, 0.3)'
                : '0 2px 8px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            maxHeight: '300px',
            overflowY: 'auto'
        },
        countryOption: {
            padding: '10px 12px',
            fontSize: '14px',
            color: isDarkMode ? '#e2e8f0' : '#2d3748',
            cursor: 'pointer',
            borderBottom: `1px solid ${isDarkMode ? '#718096' : '#e2e8f0'}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        countryOptionHover: {
            backgroundColor: isDarkMode ? '#718096' : '#edf2f7'
        },
        mobileInput: {
            flex: 1
        },
        buttonContainer: {
            marginTop: '20px'
        },
        loginButton: {
            width: '100%',
            padding: '12px',
            fontSize: '14px',
            fontWeight: '600',
            color: '#ffffff',
            background: isDarkMode
                ? 'linear-gradient(135deg, #68d391, #38a169)'
                : 'linear-gradient(135deg, #38a169, #2f855a)',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: isDarkMode
                ? '0 2px 8px rgba(104, 211, 145, 0.3)'
                : '0 2px 8px rgba(56, 161, 105, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
        },
        loginButtonDisabled: {
            opacity: 0.6,
            cursor: 'not-allowed'
        },
        loadingContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
        },
        spinner: {
            width: '16px',
            height: '16px',
            border: '2px solid transparent',
            borderTop: '2px solid white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
        },
        registerSection: {
            textAlign: 'center',
            marginTop: '20px',
            paddingTop: '16px',
            borderTop: `1px solid ${isDarkMode ? '#4a5568' : '#e2e8f0'}`
        },
        registerText: {
            color: isDarkMode ? '#a0aec0' : '#718096',
            fontSize: '12px',
            margin: 0
        },
        registerLink: {
            color: isDarkMode ? '#68d391' : '#38a169',
            textDecoration: 'none',
            fontWeight: '600',
            transition: 'all 0.2s ease'
        }
    };

    return (
        <>
            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="login-container"
                style={styles.container}
            >
                <div className="login-content">
                    <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.1, duration: 0.5 }}
                        className="login-form-container"
                        style={styles.formContainer}
                    >
                        {/* Header Section */}
                        <div className="login-header" style={styles.header}>
                            <div style={styles.logoContainer}>
                                <img
                                    src="https://i.ibb.co/nhgdzpw/image-removebg-preview-2.png"
                                    alt="Logo"
                                    style={styles.logoImage}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = 'none';
                                    }}
                                />
                            </div>
                            <h1 style={styles.title}>Welcome Back</h1>
                            <p style={styles.subtitle}>Sign in to your account</p>
                        </div>

                        {/* Login Type Selector */}
                        <div className="type-selector" style={styles.typeSelector}>
                            <button
                                type="button"
                                className="type-button"
                                style={{
                                    ...styles.typeButton,
                                    ...(loginType === 'mobile' && styles.typeButtonActive)
                                }}
                                onClick={() => handleLoginTypeChange('mobile')}
                                disabled={isLoading}
                            >
                                <FaPhone /> Mobile
                            </button>
                            <button
                                type="button"
                                className="type-button"
                                style={{
                                    ...styles.typeButton,
                                    ...(loginType === 'email' && styles.typeButtonActive)
                                }}
                                onClick={() => handleLoginTypeChange('email')}
                                disabled={isLoading}
                            >
                                <FaEnvelope /> Email
                            </button>
                        </div>

                        {/* Login Form */}
                        <form onSubmit={formik.handleSubmit} style={styles.form}>
                            {/* Login Value Field (Mobile or Email) */}
                            <div className="form-group" style={styles.formGroup}>
                                <div style={styles.labelContainer}>
                                    {loginType === 'mobile' ? (
                                        <>
                                            <FaPhone style={styles.labelIcon} />
                                            <label style={styles.label}>Mobile Number *</label>
                                        </>
                                    ) : (
                                        <>
                                            <FaEnvelope style={styles.labelIcon} />
                                            <label style={styles.label}>Email Address *</label>
                                        </>
                                    )}
                                </div>

                                {loginType === 'mobile' ? (
                                    <div className="mobile-input-container" style={styles.mobileInputContainer}>
                                        {/* Country Code Dropdown */}
                                        <div className="country-selector" style={styles.countrySelector}>
                                            <button
                                                type="button"
                                                className="country-button"
                                                style={styles.countryButton}
                                                onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                                                disabled={isLoading}
                                            >
                                                <span>+{selectedCountry?.code}</span>
                                                <FaChevronDown size={10} />
                                            </button>
                                            {showCountryDropdown && (
                                                <motion.div
                                                    initial={{ opacity: 0, y: -10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    className="country-dropdown"
                                                    style={styles.countryDropdown}
                                                >
                                                    {countryCodes.map((country) => (
                                                        <div
                                                            key={country.code}
                                                            className="country-option"
                                                            style={{
                                                                ...styles.countryOption,
                                                                ...(formik.values.countryCode === country.code && styles.countryOptionHover)
                                                            }}
                                                            onClick={() => handleCountrySelect(country.code)}
                                                        >
                                                            <span>{country.country}</span>
                                                            <span style={{ fontSize: '12px', color: isDarkMode ? '#a0aec0' : '#718096' }}>
                                                                +{country.code}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </motion.div>
                                            )}
                                        </div>
                                        {/* Mobile Number Input */}
                                        <div className="input-container" style={{ ...styles.inputContainer, ...styles.mobileInput }}>
                                            <input
                                                type="tel"
                                                name="loginValue"
                                                value={formik.values.loginValue}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder="Enter mobile number"
                                                required
                                                className="form-input"
                                                style={{
                                                    ...styles.input,
                                                    ...(formik.touched.loginValue && formik.errors.loginValue && styles.inputError),
                                                    ...(formik.values.loginValue && !formik.errors.loginValue && styles.inputSuccess)
                                                }}
                                                disabled={isLoading}
                                            />
                                            {formik.values.loginValue && !formik.errors.loginValue && (
                                                <FaUser style={styles.successIcon} />
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="input-container" style={styles.inputContainer}>
                                        <input
                                            type="email"
                                            name="loginValue"
                                            value={formik.values.loginValue}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            placeholder="Enter your email address"
                                            required
                                            className="form-input"
                                            style={{
                                                ...styles.input,
                                                ...(formik.touched.loginValue && formik.errors.loginValue && styles.inputError),
                                                ...(formik.values.loginValue && !formik.errors.loginValue && styles.inputSuccess)
                                            }}
                                            disabled={isLoading}
                                        />
                                        {formik.values.loginValue && !formik.errors.loginValue && (
                                            <FaEnvelope style={styles.successIcon} />
                                        )}
                                    </div>
                                )}

                                {formik.touched.loginValue && formik.errors.loginValue && (
                                    <span style={styles.errorText}>{formik.errors.loginValue}</span>
                                )}
                            </div>

                            {/* Password Field */}
                            <div className="form-group" style={styles.formGroup}>
                                <div style={styles.labelContainer}>
                                    <FaLock style={styles.labelIcon} />
                                    <label style={styles.label}>Password *</label>
                                </div>
                                <div className="input-container" style={styles.inputContainer}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder="Enter your password"
                                        required
                                        className="form-input"
                                        style={{
                                            ...styles.input,
                                            ...(formik.touched.password && formik.errors.password && styles.inputError),
                                            ...(formik.values.password && !formik.errors.password && styles.inputSuccess)
                                        }}
                                        disabled={isLoading}
                                    />
                                    <div
                                        className="password-toggle"
                                        style={styles.passwordToggle}
                                        onClick={togglePasswordVisibility}
                                    >
                                        {showPassword ? (
                                            <FaEyeSlash style={styles.toggleIcon} />
                                        ) : (
                                            <FaEye style={styles.toggleIcon} />
                                        )}
                                    </div>
                                </div>
                                {formik.touched.password && formik.errors.password && (
                                    <span style={styles.errorText}>{formik.errors.password}</span>
                                )}
                            </div>

                            {/* Login Button */}
                            <div style={styles.buttonContainer}>
                                <button
                                    type="submit"
                                    className="login-button"
                                    style={{
                                        ...styles.loginButton,
                                        ...(isLoading && styles.loginButtonDisabled)
                                    }}
                                    disabled={isLoading || !formik.isValid}
                                >
                                    {isLoading ? (
                                        <div style={styles.loadingContainer}>
                                            <div style={styles.spinner}></div>
                                            Signing In...
                                        </div>
                                    ) : (
                                        <>
                                            <FaSignInAlt /> Sign In
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>

                        {/* Register Link */}
                        <div className="register-section" style={styles.registerSection}>
                            <p style={styles.registerText}>
                                Don't have an account?{' '}
                                <a
                                    href="/register"
                                    style={styles.registerLink}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate('/register');
                                    }}
                                >
                                    Create Account
                                </a>
                            </p>
                        </div>
                    </motion.div>
                </div>
            </motion.div>
        </>
    );
};

export default LoginScreen;